// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4fc202d2","732":"e6bc39cd","977":"5e8a165d"}[chunkId] + ".chunk.js";
};